export default __webpack_public_path__ + "static/media/ARROW.87817b3b.png";